import { Component, inject } from '@angular/core';
import { NttLinkButton } from '@ui/button';
import { PwaInstallService } from '@core/services/pwa-install.service';

@Component({
  selector: 'ntt-install-banner',
  templateUrl: './install-banner.html',
  styleUrl: './install-banner.scss',
  imports: [NttLinkButton],
})
export class InstallBannerComponent {
  readonly pwa = inject(PwaInstallService);

  close(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.pwa.snooze();
  }
}
